import React from 'react';
import Availability from '../../models/Availability';
import i18n from '../../i18n';
import { DateRangePicker } from '@homeexchange/design';
import { getReverseRanges, useDevice } from '@homeexchange/shared';
import { getDisabledRanges } from '../../utils-ts/utils';
var DateRangePickerSelect = function (_a) {
    var availabilities = _a.availabilities, datesChange = _a.datesChange, datesError = _a.datesError, contactOnUnavailablePeriods = _a.contactOnUnavailablePeriods, startOn = _a.startOn, endOn = _a.endOn;
    var isMobile = useDevice().isMobile;
    var disabledRanges = availabilities
        .filter(function (availability) { return availability.get('type') === Availability.BOOKED.type; })
        .map(function (item) {
        return {
            end: new Date(item.get('end_on')),
            start: new Date(item.get('start_on'))
        };
    });
    var availableRanges = availabilities
        .filter(function (availability) {
        return availability.get('type') === Availability.AVAILABLE.type ||
            availability.get('type') === Availability.RECIPROCAL.type ||
            availability.get('type') === Availability.NON_RECIPROCAL.type;
    })
        .map(function (item) {
        return {
            end: new Date(item.get('end_on')),
            start: new Date(item.get('start_on'))
        };
    });
    return (React.createElement(DateRangePicker, { label: i18n.t('exchange:page.exchangeRequest.date.input.label'), endPlaceholder: i18n.t('search:filters.departure'), id: "date-range-picker", rangeCalendarProps: {
            onChange: datesChange,
            value: startOn && endOn ? { start: startOn, end: endOn } : undefined,
            locale: i18n.language,
            monthsToDisplay: isMobile ? 1 : 2,
            disablePastDates: true,
            disabledRanges: contactOnUnavailablePeriods
                ? getDisabledRanges(disabledRanges)
                : getReverseRanges(availableRanges)
        }, startPlaceholder: i18n.t('search:filters.arrival'), popoverProps: { isInModal: true }, message: datesError === 'datesSameDay'
            ? i18n.t('exchange:page_exchangeRequest_date_input_sameDate_error')
            : i18n.t('exchange:page.exchangeRequest.date.input.error'), status: datesError ? 'error' : undefined }));
};
export default DateRangePickerSelect;
